import { useEffect, useLayoutEffect, useState } from 'react'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

export default function useBlockScroll(initialState = false, rootId = '___gatsby') {
   const [locked, setLocked] = useState(initialState)

   useIsomorphicLayoutEffect(() => {
      if (!locked) {
         return
      }

      // Save initial body style
      const originalOverflow = document.body.style.overflow
      const originalPaddingRight = document.body.style.paddingRight
      const html = document.documentElement

      // Lock body scroll
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'relative' /* [1] */
      html.style.position = 'relative' /* [1] */
      html.style.overflow = 'hidden' /* [2] */

      // Get the scrollBar width
      const root = document.getElementById(rootId) // or root

      const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0

      // Avoid width reflow
      if (scrollBarWidth) {
         document.body.style.paddingRight = `${scrollBarWidth}px`
      }

      return () => {
         document.body.style.overflow = originalOverflow
         html.style.position = ''
         html.style.overflow = ''
         if (scrollBarWidth) {
            document.body.style.paddingRight = originalPaddingRight
         }
      }
   }, [locked])

   // Update state if initialValue changes
   useEffect(() => {
      if (locked !== initialState) {
         setLocked(initialState)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [initialState])

   return [locked, setLocked]
}
